<template>
  <Modal width="1080" v-model="show" :mask-closable="false"  :loading="loading">
      <div slot="header" class="modal-header">添加自如智能家居</div>
      <Form :model="formData" :label-width="85" :rules="formRules" ref="formValidate">
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="项目名称" prop="projectFid">
              <Select v-model="formData.projectFid" @on-change="changeProject">
                <Option value="">请选择</Option>
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="楼栋" prop="houseBuildingFid">
              <Select v-model="formData.houseBuildingFid" @on-change="changeBuilding">
                <Option  v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <!--  -->
          
          <!-- <Col :span="8">
            <FormItem label="房间号" prop="stockFid">
              <Select
                v-model="formData.stockFid"
                filterable
                remote
                :remote-method="remoteMethod"
                :loading="searchLoading"
                :defaultTem='true'
                placeholder="请输入房间号/床位号">
                <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col> -->
          <!-- 
        -->
       
        <div class="flex">
              <div class="roomlist">
                <h4 class="mb8">房间列表</h4>
                <Tabs type="card">
                  <Tab-pane label="整租">
                    <ul>
                      <li class="top" v-for="(item,index) in canSelect"
                          :class="['ivu-btn',{'btn-primary2':item.isSelected}]"
                          :key="'keyA'+index"
                          @click.stop="selectItem(item)"
                      >{{item.stockNumber}}
                      </li>
                    </ul>
                  </Tab-pane>
                  <Tab-pane label="合租">
                    <ul>
                      <li class="top" v-for="(item,index) in canSelect2" :key="'keyA'+index">
                        <span :class="['icon-arrow ivu-icon',item.switch?'ivu-icon-arrow-down-b':'ivu-icon-arrow-right-b']" style="display:inline-block" @click="getSmall(index,item.fid)"></span>
                        <span :class="['ivu-btn',{'btn-primary2':item.isSelected}]" @click.stop="selectItem(item,index)">{{item.stockNumber}}</span>
                        <div v-if="item.switch">
                        <span
                          style="margin-left:10px;margin-top:10px"
                          v-for="(item2,index2) in item.canSelectSmall2" :key="'a'+index2"
                          :class="['ivu-btn',{'btn-primary2':item2.isSelected}]"
                          @click.stop="selectItem(item2,index)"
                        >
                        {{item2.stockNumber}}
                        </span>
                        </div>
                      </li>
                    </ul>
                  </Tab-pane>
                  <Tab-pane label="公共区域">
                    <ul>
                      <li class="top" v-for="(item,index) in commonList"
                          :class="['ivu-btn',{'btn-primary2':item.isSelected}]"
                          :key="'keyA'+index"
                          @click.stop="selectItem(item)"
                      >{{item.name}}
                      </li>
                    </ul>
                  </Tab-pane>
                </Tabs>
              </div>
              <div class="checklist">
                <h4 class="mb8">已选列表</h4>
                <Tabs type="card">
                  <Tab-pane label="整租">
                    <ul>
                      <li v-for="(item,index) in checkList" class="top ivu-btn btn-primary2"
                          :key="'keyB'+index"
                          @click.stop="selectItem(item)"
                      >{{item.stockNumber}}
                      </li>
                    </ul>
                  </Tab-pane>
                  <Tab-pane label="合租">
                    <ul>
                      <li style="margin:0 10px 10px 0" v-for="(item,index) in canSelect2" :key="'keyA'+index">
                        <!-- <span v-if="item.isSelected" class="icon-arrow" style="display:inline-block" @click="getSmall(index,item.fid)"></span> -->
                        <span class="rightBtn" v-if="item.isSelected" :class="['ivu-btn',{'btn-primary2':item.isSelected}]" @click.stop="selectItem(item)">{{item.stockNumber}}</span>
                        <!-- <div> -->
                        <span
                          class="rightBtn"
                          v-for="(item2,index2) in item.canSelectSmall2" :key="'a'+index2"
                          :class="['ivu-btn',{'btn-primary2':item2.isSelected}]"
                          @click.stop="selectItem(item2)"
                          v-if="item2.isSelected"
                        >
                        {{item2.stockNumber}}
                        </span>
                        <!-- </div> -->
                      </li>
                    </ul>
                  </Tab-pane>
                  <Tab-pane label="公共区域">
                    <ul>
                      <li v-for="(item,index) in checkList3" class="top ivu-btn btn-primary2"
                          :key="'keyB'+index"
                          @click.stop="selectItem(item)"
                      >{{item.name}}
                      </li>
                    </ul>
                  </Tab-pane>
                </Tabs>
              </div>
            </div>
          <Row style="text-align:right;margin-top:10px">
            <Button type="primary" size="small" style="margin-top:5px" @click="addFurniture">添加智能家居</Button>
          </Row> 
        <furniture-item v-for="(item,index) in dataList"
                    :deleteShow="index>0"
                    :formData="item"
                    :itemIndex="index"
                    :zhengzu="zhengzu"
                    :hezu="hezu"
                    :hezuffj="hezuffj"
                    :gongqu="gongqu"
                    :hezuzfj="hezuzfj"
                    @deleteItem="deleteItem"
                    :ref="'builditem'+index"
                    :key="'keyA'+index"
        ></furniture-item>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading">
          <span v-if="!loading">保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </Modal>
</template>

<script type="text/ecmascript-6">
import FurnitureItem from './FurnitureItem'
import {formatDateTime} from "@/utils/format";
import { fuzzyRoom } from 'api/functionalArea'
import {  getHouseType, getSelectData } from "api/house"
import { addFurniture ,parentListNoPage,areaList,subList} from "api/smartWorkOrder"
export default {
  components:{
    FurnitureItem
  },
  props: {
    n: {
      type: Number,
      default: 0
    },
    projectList:{
       type:Array,
       default:[]
    },
    
  },
  watch: {
		n() {
      this.$refs['formValidate'].resetFields();
      this.formData.projectFid = this.projectList[0].value
      this.loading = false;
      this.show = true;
      this.dataList=[
        {
          "areaTypeCode": '',
          prodTypeIds: []
        },
      ]
    },
    canSelect:{
      deep:true,
      handler(){
        this.checkList =  this.canSelect.filter(ele => {
          return ele.isSelected
          })
        this.stockFids = this.checkList.map(ele => {
          return ele.fid
        })
        if(this.stockFids.length>0){
          this.zhengzu = true
        } else{
          this.zhengzu = false
        }
      }
    },
    canSelect2:{
      deep:true,
      handler(){
        this.checkList2 =  this.canSelect2.filter(ele => {
          return ele.isSelected
        })
        this.checkListSmall2 = [];
        this.canSelect2.forEach(ele=>{
          if(ele.hasOwnProperty('canSelectSmall2')){
            this.checkListSmall2 = this.checkListSmall2.concat(ele.canSelectSmall2.filter(e=>{
              return e.isSelected;
            }))
          }
          return false
        })
        if(this.checkListSmall2.length > 0){
          this.hezuzfj = true;
        } else{
          this.hezuzfj = false
        }
        if(this.checkList2.length > 0){
          this.hezuffj = true
        } else{
          this.hezuffj = false
        }
        this.checkHeZu = this.checkList2.concat(this.checkListSmall2);
        this.stockFids2 = this.checkHeZu.map(ele => {
          return ele.fid
        })
        if(this.stockFids2.length>0){
          this.hezu = true
        } else{
          this.hezu = false
        }
      }
    },
    commonList:{
      deep:true,
      handler(){
        this.checkList3 =  this.commonList.filter(ele => {
          return ele.isSelected
          })
        this.stockFids3 = this.checkList3.map(ele => {
          return ele.fid
        })
        if(this.stockFids3.length>0){
          this.gongqu = true
        } else{
          this.gongqu = false
        }
      }
    },
  },

  data () {
    return {
      hasDone:[],
      subListArr:[],
      checkList:[],
      checkList2:[],
      checkList3:[],
      stockFids:[],
      stockFids2:[],
      stockFids3:[],
      checkListSmall2:[],
      zhengzu:false,
      hezu:false,
      gongqu:false,
      hezuzfj:false,
      hezuffj:false,
      commonList:[],
      houseBuildingFid:'',
      canSelect:[],
      canSelect2:[],
      show:false,
      loading:false,
      searchLoading:false,
      buildingList:[],
      houseTypeList:[],
      formData: {
        projectFid: "",
        stockFids: [],
        areas:[]
      },
      roomList:[],
      dataList:[
        {
          "areaTypeCode": '',
          prodTypeIds: []
        },
      ],
      formRules:{
        projectFid:[{ required: true, type:'string', message:'请选择项目名称', trigger: 'change'}],
        houseBedType:[{ required: true, type:'number', message:'请选择床类型', trigger: 'change'}],
        houseRentType:[{ required: true, type:'number',message:'请选出租类型',trigger: 'change'}],
        houseBuildingFid:[{ required: true, type:'string', message:'请选择楼栋', trigger: 'change'}],

			},
    };
  },
  methods:{
    getSmall(index,id){
      this.canSelect2[index].switch = !this.canSelect2[index].switch;
      //已经请求过接口的就不要请求了

      if(this.hasDone.indexOf(index) > -1){
        return false
      }  
      this.hasDone.push(index);
      subList({'stockFid':id})
      .then(res=>{
        this.canSelect2[index].canSelectSmall2 = res.data;
        this.canSelect2[index].canSelectSmall2.forEach(ele=>{
          ele['isSelected'] = false;
        })
        this.$forceUpdate();
      })
    },
    changeProject(value) {
      this.dataList.forEach(ele=>{
        ele.prodTypeIds = []
      })
      if(value === '') {
        this.buildingList = []
      }else{
        let project = this.projectList.find( item => {
          return item.value === value
        })
        if(project === undefined) {
          this.$Message.error('获取楼栋信息错误');
        } else {
          this.buildingList = project.children
          this.hasDone = []
          // this.formData.houseBuildingFid = this.buildingList[0].value
        }
      }
    },
    changeBuilding(value) {
      this.canSelect = []
      this.canSelect2 = []
      this.commonList = []
      this.hasDone = []
      if(value) {
        this.getZhengzu();
        this.getHezu();
        this.getAreaList();
      }
    },
    getZhengzu(){
      let params = {
        projectFid: this.formData.projectFid,
        houseBuildingFid: this.formData.houseBuildingFid,
        stockRentType:0,
      }
      parentListNoPage(params).then(res => {
        if (res.data.length ===0) {
          // this.$Message.info('整租不存在可选房间')
          return
        }
        res.data.forEach(ele => {
          this.$set(ele,'isSelected',false)
          // ele['isSelected'] = false
        })
        this.canSelect = res.data
      }).catch(error => {
      })
    },
    getAreaList(){
      let params = {
        projectId: this.formData.projectFid,
        buildingId: this.formData.houseBuildingFid,
        area:2,
      }
      areaList(params)
      .then(res=>{
        if(res.data.length === 0){
          // this.$Message.info('公共区域不存在可选房间')
          return
        }
        res.data.forEach(ele => {
          this.$set(ele,'isSelected',false)

        })
        this.commonList = res.data;
      })
    },
    getHezu(){
      let params = {
        projectFid: this.formData.projectFid,
        houseBuildingFid: this.formData.houseBuildingFid,
        stockRentType:1,
      }
      parentListNoPage(params).then(res => {
        if (res.data.length === 0) {
          // this.$Message.info('合租不存在可选房间')
          return
        }
        res.data.forEach(ele => {
          this.$set(ele,'isSelected',false)
          this.$set(ele,'switch',false)
          // ele['isSelected'] = false
        })
        this.canSelect2 = res.data
      }).catch(error => {
      })
    },
    selectItem(item,index){
      item.isSelected = !item.isSelected
      this.canSelect2 = [].concat(this.canSelect2);
    },
    remoteMethod(query){
      if (query && this.formData.projectFid) {
        this.searchLoading = true;
        let params = {
          projectid:this.formData.projectFid,
          roomnumber:query
        }
        fuzzyRoom(params).then( res => {
          this.searchLoading = false;
          this.roomList = res.data;
        })
      } else {
        this.roomList = [];
        this.formData.stockFids = []
      }
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    addFurniture(){
      this.dataList.push(
        {
          "areaTypeCode": '',
          prodTypeIds: []
        }
      )
    },
    deleteItem(index){
      this.$Modal.confirm({
        content:'<p>确认删除本条智能家居记录？</p>',
        onOk:()=>{
          this.dataList.splice(index,1)
        }
      })
    },
    handleCancel(){
      this.show = false
    },
    save() {
      let data = null
      this.$refs['formValidate'].validate( bool => {
        if(bool){
          this.formData.stockFids = this.stockFids.concat(this.stockFids2).concat(this.stockFids3);
          if(this.formData.stockFids.length === 0){
            this.$Message.info('请选择房间')
            this.loading = false
            return
          }
          if(this.formData.stockFids.length > 30){
            this.$Message.info('最多可下单30个房间')
            this.loading = false
            return
          }
          this.formData.areas = this.dataList
          let f = true
          this.formData.areas.forEach(ele=>{
            if(!ele.areaTypeCode){
              this.$Message.info('请选择智能平台位置')
              this.loading = false
              f = false
              return
            }
            if(ele.prodTypeIds.length===0){
              this.$Message.info('智能家具物品')
              this.loading = false
              f = false
            }
          })
          if(!f){
            return
          }
          this.loading = true
          addFurniture(this.formData).then(res => {
            this.loading = false
            this.$Message.success('智能平台添加安装智能家居工单成功');
            this.$emit('refresh')
            this.show=false
          }).catch( res => {
            this.loading=false
            this.show = false
            this.$emit('refresh')

          })
        }
      });
    }
  }

}
</script>
<style  scoped>
.icon-arrow{
  width: 10px;
  height: 10px;
}
  .flex {
    display: flex;
    border: 1px solid #DDDEE1;
  }

  .roomlist {
    flex: none;
    width: 51%;
    border-right: 1px solid #DDDEE1;
    padding: 15px;
  }

  .checklist {
    flex: auto;
    padding: 15px;
  }

  li.top {
    margin: 0 10px 10px 0; 
    width: 100px;
    float: left;
  }
  .rightBtn{
width:80px;margin-left:10px;margin-top:10px
  }
</style>
